import type { Apis } from '../context/page-context';
import { AccountApi } from '../features/account/api';
import { APISettingsApi } from '../features/api-settings/api';
import { BillingApi } from '../features/billing/api';
import { CompaniesApi } from '../features/companies/api';
import { CustomerGroupsApi } from '../features/customer-groups/api';
import { CustomersApi } from '../features/customers/api';
import { DiscountsApi } from '../features/discounts/api';
import { PlatformApi } from '../features/platform/api';
import { PriceListsApi } from '../features/price-lists/api';
import { PricingApi } from '../features/pricing/api';
import { ProductsApi } from '../features/products/api';
import { PurchasingApi } from '../features/purchases/api/purchasing';
import { ShippingMethodsApi } from '../features/shipping-methods/api';
import { StaffApi } from '../features/staff/api';
import { StockApi } from '../features/stock/api';
import { StorefrontOptionsApi } from '../features/storefront-options/api';
import { SparkJsApi } from '../features/storefront-widgets/api';
import { SyncApi } from '../features/sync/api';
import { ThemesApi } from '../features/themes/api';
import type { ApiHandlerContract } from '../types/handlers/api';
import { CubeApi } from './cube';
import { SiteApi } from './site';
import { StockLocationsApi } from './stock-locations';

// Composition root: the only place the raw apiHandler is consumed in production.
export function buildApis(apiHandler: ApiHandlerContract): Apis {
  return {
    billing: new BillingApi(apiHandler),
    companies: new CompaniesApi(apiHandler),
    customers: new CustomersApi(apiHandler),
    customerGroups: new CustomerGroupsApi(apiHandler),
    discounts: new DiscountsApi(apiHandler),
    priceLists: new PriceListsApi(apiHandler),
    pricing: new PricingApi(apiHandler),
    platform: new PlatformApi(apiHandler),
    products: new ProductsApi(apiHandler),
    shippingMethods: new ShippingMethodsApi(apiHandler),
    sparkJs: new SparkJsApi(apiHandler),
    storefrontOptions: new StorefrontOptionsApi(apiHandler),
    purchases: new PurchasingApi(apiHandler),
    account: new AccountApi(apiHandler),
    sync: new SyncApi(apiHandler),
    site: new SiteApi(apiHandler),
    stock: new StockApi(apiHandler),
    stockLocations: new StockLocationsApi(apiHandler),
    themes: new ThemesApi(apiHandler),
    staff: new StaffApi(apiHandler),
    cube: new CubeApi(apiHandler),
    APISettings: new APISettingsApi(apiHandler),
  };
}
